import { LineUpPlayerCardProps } from '@stadionhq-v3/football-ui';

export const orderByShirtNumber = <T extends { shirtNumber?: number }>(
  profiles: T[]
): Array<T> =>
  profiles?.sort((a: LineUpPlayerCardProps, b: LineUpPlayerCardProps) =>
    (a.shirtNumber || 0) < (b.shirtNumber || 0) ? -1 : 1
  );
